
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(9(248|703|859)|1(012|59|90)|44(27|61)|2928|3922|5868|5974|7933)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
